__turbopack_context__.v({
  "columnsDropdown": "Navbar-module__E3zbLa__columnsDropdown",
  "columnsDropdownArrow": "Navbar-module__E3zbLa__columnsDropdownArrow",
  "columnsDropdownContent": "Navbar-module__E3zbLa__columnsDropdownContent",
  "columnsDropdownContentli": "Navbar-module__E3zbLa__columnsDropdownContentli",
  "columnsDropdownMobile": "Navbar-module__E3zbLa__columnsDropdownMobile",
  "hamburger": "Navbar-module__E3zbLa__hamburger",
  "hamburgerIcon": "Navbar-module__E3zbLa__hamburgerIcon",
  "li": "Navbar-module__E3zbLa__li",
  "mobileCloseButton": "Navbar-module__E3zbLa__mobileCloseButton",
  "mobileDropdown": "Navbar-module__E3zbLa__mobileDropdown",
  "mobileDropdownArrow": "Navbar-module__E3zbLa__mobileDropdownArrow",
  "mobileDropdownButton": "Navbar-module__E3zbLa__mobileDropdownButton",
  "mobileNav": "Navbar-module__E3zbLa__mobileNav",
  "mobileNavContainer": "Navbar-module__E3zbLa__mobileNavContainer",
  "mobileNavLinks": "Navbar-module__E3zbLa__mobileNavLinks",
  "mobileThemeToggle": "Navbar-module__E3zbLa__mobileThemeToggle",
  "mobileThemeToggleContainer": "Navbar-module__E3zbLa__mobileThemeToggleContainer",
  "mobileThemeToggleContent": "Navbar-module__E3zbLa__mobileThemeToggleContent",
  "mobileThemeToggleIcon": "Navbar-module__E3zbLa__mobileThemeToggleIcon",
  "mobileThemeToggleLabel": "Navbar-module__E3zbLa__mobileThemeToggleLabel",
  "mobileThemeToggleSubtext": "Navbar-module__E3zbLa__mobileThemeToggleSubtext",
  "navbar": "Navbar-module__E3zbLa__navbar",
  "navbarLinks": "Navbar-module__E3zbLa__navbarLinks",
  "navbarLogo": "Navbar-module__E3zbLa__navbarLogo",
  "navbarScrolled": "Navbar-module__E3zbLa__navbarScrolled",
  "signOutDesktop": "Navbar-module__E3zbLa__signOutDesktop",
  "signOutMobile": "Navbar-module__E3zbLa__signOutMobile",
});
